export enum DeviceClassification {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
}

export interface DeviceType {
  type?: '.DeviceType';
  deviceType?: DeviceClassification;
}
